import { render, staticRenderFns } from "./PrintBillFrame.vue?vue&type=template&id=391d81b2&scoped=true"
import script from "./PrintBillFrame.vue?vue&type=script&lang=js"
export * from "./PrintBillFrame.vue?vue&type=script&lang=js"
import style0 from "./PrintBillFrame.vue?vue&type=style&index=0&id=391d81b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391d81b2",
  null
  
)

export default component.exports